<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <a-input v-decorator="['itemCode']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="规格描述">
              <a-input v-decorator="['specification']" allowClear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料类型" :help="null">
              <global-select
                v-decorator="['itemType', { rules: [{ required: true }], initialValue: ['CP', 'ZCBCP'] }]"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'MDM_ITEM_TYPE' }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmItemMaintenanceNewExport" ref="download" />
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['mdm:mdmItemMaintenance:produceImport']">导入</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:mdmItemMaintenance:produceExport']">导出</a-button>
      <!-- <a-button @click="importTemplate">下载模板</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.PRODUCTION_ATTRIBUTES_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:mdmItemMaintenance:produceEdit']">编辑</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== record.id">{{ meaning(record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === record.id"
                  :value.sync="record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                  :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                  @change="selectChange(item.dataIndex, record)"
                />
              </span>
              <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiMdmItemMaintenanceProduceEdit, apiMdmItemMaintenanceProduceList, apiMdmItemMaintenanceNewExport } from '@/api/mdm/matter/production-attributes'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Production-attributes',
  components: { DownloadModal },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
       apiMdmItemMaintenanceNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiMdmItemMaintenanceProduceList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/mdmItemMaintenance/produceImport'
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '物料类型',
          dataIndex: 'itemType',
          align: 'center'
        },
        {
          title: 'WIP供应类型',
          dataIndex: 'wipSupplyType',
          scopedSlots: { customRender: 'wipSupplyType' },
          align: 'center',
          width: 150,
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupValue',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '工艺分层',
          dataIndex: 'techniqueStructure',
          scopedSlots: { customRender: 'techniqueStructure' },
          align: 'center',
          width: 150,
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '产品族',
          dataIndex: 'productGroup',
          scopedSlots: { customRender: 'productGroup' },
          align: 'center',
          width: 150,
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '最后修改人',
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          align: 'center',
          width: 170,
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  mounted () {
    this.handleQuery()
  },
  methods: {
    // 表单搜索
    onSearch () {
      if (this.form.getFieldsValue().itemType.length === 0) {
        this.$message.warning('物料类型不能为空')
        return;
      }
      const obj = JSON.parse(JSON.stringify(this.form.getFieldsValue()))
      obj.organizationCode = this.organizationCodeOrigin
      this.$refs.dataTable.searchParams = obj
      this.$refs.dataTable.getData();
      this.isEdit = false
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }

      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      apiMdmItemMaintenanceProduceEdit(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.handleQuery()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.handleQuery()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    meaning (record, dataIndex) {
      return record[dataIndex]
    },
    selectChange (val, record) {},
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "techniqueStructure") {
        return { lookupType: 'MDM_TECHNIQUE_STRUCTURE' }
      }
      if (dataIndex === "productGroup") {
        return { lookupType: 'MDM_PRODUCT_GROUP' }
      }
      if (dataIndex === 'wipSupplyType') {
        return { lookupType: 'MES_SUPPLY_TYPE' }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('mdm/mdmItemMaintenance/producelsTemplate', {
        ...this.form.getFieldsValue()
      }, `生产属性维护导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.form.getFieldsValue()
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmItemMaintenance/produceExport', {
      //   ...this.form.getFieldsValue()
      // }, `生产属性维护_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
.page-header-content{
  /deep/.ant-select{
    width: 140px;
  }
}
</style>
